export function Input({ label, className = '', ...props }) {
  return (
    <label className="block">
      {label && <span className="block mb-1 text-sm font-medium text-slate-600 dark:text-slate-300">{label}</span>}
      <input
        className={`w-full px-3 py-2 rounded-lg border border-slate-300 dark:border-white/15 bg-white dark:bg-slate-800 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-brand/40 ${className}`}
        {...props}
      />
    </label>
  );
}
